import React from 'react';

import StopIcon from '@mui/icons-material/Stop';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

const FinishActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles();

  return (
    <BaseActionButton {...props}>
      <StopIcon />
    </BaseActionButton>
  );
};

export default FinishActionButton;
